import React from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import EmailInput from '@components/UI-KIT/Inputs/EmailInput';
import Button from '@components/UI-KIT/Button';

// Icons
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

interface Props {
    emailSend: boolean;
    failMail: boolean;
    inputError: boolean;
    email: string;
    emailHandler: (_value: string) => void;
    Recovery: () => Promise<void>;
    goBackFunction: () => void;
    returnToLogin: () => void;
}

const EmailRequestHandler: React.FC<Props> = ({
    emailSend,
    email,
    emailHandler,
    failMail,
    Recovery,
    inputError,
    goBackFunction,
    returnToLogin
}) => {

    return (
        <>
            { !emailSend ? (
                <Grid
                    className="AOL-Session-main-login-frame"
                >
                    <Typography
                        variant="h3"
                        color="primary-dark"
                    >
                        Cambia tu contraseña
                    </Typography>
                    <Grid
                        className="AOL-Session-login-margin"
                    >
                        <Typography
                            color="primary-dark"
                        >
                            Sigue las instrucciones que te enviaremos al e-mail asociado  a tu usuario.
                        </Typography>
                    </Grid>
                    <Grid
                        className="AOL-Session-login-forms"
                    >
                        <EmailInput
                            value={email}
                            onChange={emailHandler}
                            errorCase={failMail}
                            label="E-mail de tu usuario"
                            xs={12}
                            errorLabel="El email no pertenece a un usuario."
                        />
                    </Grid>
                    <Grid
                        style={{ marginTop: '2rem' }}
                    >
                        <Button
                            onClick={Recovery}
                            disabled={inputError}
                            level={1}
                            label="Enviar"
                            className="AOL-Session-login-btn"
                        />
                    </Grid>
                    <Grid
                        className="AOL-Session-login-recovery-margin"
                    >
                        <Button
                            level={4}
                            icon={<ArrowBackIcon/>}
                            onClick={goBackFunction}
                            label="Volver"
                        />
                    </Grid>
                </Grid>
            ) : (
                <Grid
                    className="AOL-Session-main-login-frame"
                    style={{ marginTop: '8rem' }}
                >
                    <Grid
                        container
                        wrap="nowrap"
                    >
                        <img
                            src="Base.png"
                            alt="logo"
                        />
                        <Grid
                            className="AOL-Session-recovery-margin"
                        >
                            <Typography
                                variant="h2"
                                color="primary-dark"
                            >
                                ¡Oki! e-mail enviado
                            </Typography>

                        </Grid>
                    </Grid>
                    <Grid
                        className="AOL-Session-login-margin"
                    >
                        <Typography
                            variant="body-regular"
                            color="primary-dark"
                        >
                            En unos instantes deberías recibir las instrucciones para cambiar tu contraseña. Si no recibiste el correo, quizás puede estar en la carpeta de spam o correo no deseado :P
                        </Typography>
                    </Grid>
                    <Grid
                        className="AOL-Session-login-recovery-margin"
                    >
                        <Button
                            level={1}
                            onClick={returnToLogin}
                            label="Aceptar"
                            className="AOL-Session-login-btn"
                        />
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default EmailRequestHandler;